import { render, staticRenderFns } from "./VehicleTrace.vue?vue&type=template&id=2c6c086f&scoped=true"
import script from "./VehicleTrace.vue?vue&type=script&lang=js"
export * from "./VehicleTrace.vue?vue&type=script&lang=js"
import style0 from "./VehicleTrace.vue?vue&type=style&index=0&id=2c6c086f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c086f",
  null
  
)

export default component.exports